import { c as _c } from "react/compiler-runtime";
import { getOrgAgentsOptions } from '@onefootprint/fetch-dashboard';
import { Button, Form, LoadingSpinner } from '@onefootprint/ui';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDebounce } from 'usehooks-ts';
const AgentPicker = () => {
  const $ = _c(43);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "credentials.dialog.fields"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t0);
  const [search, setSearch] = useState("");
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [selectedOptions, setSelectedOptions] = useState(t1);
  let t2;
  if ($[2] !== search) {
    t2 = search.trim();
    $[2] = search;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const trimmedSearch = t2;
  const debouncedSearch = useDebounce(trimmedSearch, 300);
  let t3;
  if ($[4] !== debouncedSearch) {
    t3 = getOrgAgentsOptions({
      query: {
        search: debouncedSearch,
        pageSize: 10
      }
    });
    $[4] = debouncedSearch;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = debouncedSearch.length > 0;
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = {
      ...t3,
      enabled: t4,
      retry: false,
      placeholderData: keepPreviousData
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    data,
    isFetching,
    error,
    refetch
  } = useQuery(t5);
  const isSearching = isFetching || trimmedSearch !== debouncedSearch;
  let t6;
  if ($[9] !== data?.data || $[10] !== error || $[11] !== trimmedSearch) {
    t6 = !trimmedSearch || error ? [] : data?.data.map(_temp) ?? [];
    $[9] = data?.data;
    $[10] = error;
    $[11] = trimmedSearch;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const options = t6;
  let t7;
  if ($[13] !== error || $[14] !== isSearching || $[15] !== refetch || $[16] !== t || $[17] !== trimmedSearch) {
    t7 = () => {
      if (!trimmedSearch) {
        return t(_temp2);
      }
      if (isSearching) {
        return <LoadingSpinner />;
      }
      if (error) {
        return <div role="alert" className="flex flex-col items-center gap-2"><span>{t(_temp3)}</span><Button type="button" size="compact" onClick={() => refetch()}>{t(_temp4)}</Button></div>;
      }
      return t(_temp5);
    };
    $[13] = error;
    $[14] = isSearching;
    $[15] = refetch;
    $[16] = t;
    $[17] = trimmedSearch;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const emptyState = t7;
  let t8;
  if ($[19] !== t) {
    t8 = t(_temp6);
    $[19] = t;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t) {
    t9 = t(_temp7);
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== data?.meta.next || $[24] !== error || $[25] !== isSearching || $[26] !== t || $[27] !== trimmedSearch) {
    t10 = data?.meta.next && trimmedSearch && !isSearching && !error ? t(_temp8) : t(_temp9);
    $[23] = data?.meta.next;
    $[24] = error;
    $[25] = isSearching;
    $[26] = t;
    $[27] = trimmedSearch;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  const t11 = isSearching && options.length > 0;
  let t12;
  if ($[29] !== emptyState) {
    t12 = emptyState();
    $[29] = emptyState;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== options || $[32] !== selectedOptions) {
    t13 = ids => {
      const knownOptions = [...selectedOptions, ...options];
      setSelectedOptions(knownOptions.filter((option, index) => ids.includes(option.value) && knownOptions.findIndex(item => item.value === option.value) === index));
    };
    $[31] = options;
    $[32] = selectedOptions;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== options || $[35] !== selectedOptions || $[36] !== t10 || $[37] !== t11 || $[38] !== t12 || $[39] !== t13 || $[40] !== t8 || $[41] !== t9) {
    t14 = <Form.MultiSelect name="agentIds" size="compact" label={t8} placeholder={t9} hint={t10} hideSelectAll={true} options={options} isLoading={t11} selectedOptions={selectedOptions} onSearchChange={setSearch} emptyState={t12} onChange={t13} />;
    $[34] = options;
    $[35] = selectedOptions;
    $[36] = t10;
    $[37] = t11;
    $[38] = t12;
    $[39] = t13;
    $[40] = t8;
    $[41] = t9;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  return t14;
};
export default AgentPicker;
function _temp(agent) {
  return {
    label: agent.name,
    value: agent.id
  };
}
function _temp2($) {
  return $.agentsSearchPrompt;
}
function _temp3($_0) {
  return $_0.agentsSearchError;
}
function _temp4($_1) {
  return $_1.agentsSearchRetry;
}
function _temp5($_2) {
  return $_2.agentsSearchEmpty;
}
function _temp6($_3) {
  return $_3.agents;
}
function _temp7($_4) {
  return $_4.agentsPlaceholder;
}
function _temp8($_5) {
  return $_5.agentsSearchMore;
}
function _temp9($_6) {
  return $_6.agentsHint;
}